export default function getScrollY(id,length){
  let returnH = 0
  const dev = document.getElementById(id)
  if(dev){
    const height = dev.clientHeight - 95
    if(height < length * 32){
      returnH = height
    }
  }
  return returnH
}
